export const getGoogleDriveDownloadUrl = (url: string): string => {
  if (!url.includes("drive.google.com")) {
    return url;
  }

  const fileIdMatch = url.match(/\/d\/([a-zA-Z0-9-_]+)/);
  if (fileIdMatch && fileIdMatch[1]) {
    return `https://drive.google.com/uc?export=download&id=${fileIdMatch[1]}`;
  }

  return url;
};

export const openUrlWithGoogleDriveSupport = (url: string): void => {
  const finalUrl = getGoogleDriveDownloadUrl(url);
  window.open(finalUrl, "_blank", "noopener,noreferrer");
};
